import { Box, Stack, Typography } from '@mui/material'

export interface HistoryValueBoxProps {
  icon: React.ReactNode
  label: string
  value: string
}

export const HistoryValueBox = ({ icon, label, value }: HistoryValueBoxProps) => {
  return (
    <Stack alignItems="center" justifyContent="center" flex={1} p={1}>
      <Box sx={{ color: 'text.secondary', display: 'flex', mb: 0.5 }}>{icon}</Box>
      <Typography variant="caption" textAlign="center" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body2" fontWeight="bold" textAlign="center" color="text.primary">
        {value}
      </Typography>
    </Stack>
  )
}
